// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"2c2eb6cf","76":"688d5a10","136":"6e3aacc6","487":"31991635","674":"29e4d0e5","721":"bdf4c575"}[chunkId] + ".chunk.css";
};